import React, { useState, useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
// import Button from "@mui/material/Button";
import CryptoJS from "crypto-js";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LockIcon from "@mui/icons-material/Lock";
import DvrIcon from "@mui/icons-material/Dvr";
import NfcIcon from "@mui/icons-material/Nfc";
// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import HubIcon from "@mui/icons-material/Hub";
// import AnalyticsIcon from "@mui/icons-material/Analytics";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import DatasetIcon from "@mui/icons-material/Dataset";
import SourceIcon from "@mui/icons-material/Source";
import SettingsIcon from "@mui/icons-material/Settings";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import MenuIcon from "@mui/icons-material/Menu";
import toast from "react-hot-toast";
// import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import CircleSharpIcon from "@mui/icons-material/CircleSharp";
import images from "../../Resources/Images";
import "../../Assets/css/sidePanel.css";
import { useNavigate } from "react-router-dom";
import AppContext from "../../Store/AppContext";

// import FileDownloadModal from "./FileDownloadModal";
export default function SidePanel() {
  const {
    setProductCode,
    handleDataEncryption,
    setRegulationCode,
    clientDetails,
  } = useContext(AppContext);
  // const [open, setOpen] = useState(false);
  // console.log("clientDetails :", clientDetails);
  const [openList, setOpenList] = useState(null);
  // const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [state, setState] = useState({
    left: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const navigate = useNavigate();

  const lists = [
    {
      name: "Regulatory Reference Data",
      items: ["UK FIRDS", "EU FIRDS", "UPI", "GLIEF"],
    },
  ];
  const secretKey = localStorage.getItem("userToken").slice(27, 47);
  const handleGetDecryptedRegulationCode = () => {
    const encryptedString = localStorage.getItem("RegDataVal6");
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedString, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      setProductCode(decryptedData);
      setRegulationCode(decryptedData);

      return null;
    } catch (error) {
      console.error("Error during decryption:", error.message);
      return null;
    }
  };
  const handleItemClick = (item) => {
    // console.log(item, '---item');
    // navigate("/regulatory-reference");
    switch (item) {
      case "UK FIRDS":
        handleDataEncryption("RegDataVal6", "R005", secretKey);
        handleGetDecryptedRegulationCode();
        localStorage.setItem("regulationName", "UK FIRDS");
        navigate("/regulatory-reference/ukfirds");

        break;
      case "EU FIRDS":
        handleDataEncryption("RegDataVal6", "R006", secretKey);
        handleGetDecryptedRegulationCode();
        localStorage.setItem("regulationName", "EU FIRDS");
        navigate("/regulatory-reference/eufirds");
        break;
      case "UPI":
        handleDataEncryption("RegDataVal6", "R007", secretKey);
        handleGetDecryptedRegulationCode();
        localStorage.setItem("regulationName", "UPI ");
        navigate("/regulatory-reference/upi");
        break;
      case "GLIEF":
        handleDataEncryption("RegDataVal6", "R008", secretKey);
        handleGetDecryptedRegulationCode();
        localStorage.setItem("regulationName", "GLIEF");
        navigate("/regulatory-reference/glief");
        break;
      default:
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
    }
  };
  const handleListClick = (listName) => {
    setOpenList(openList === listName ? null : listName);
  };

  const listIcons = {
    "Regulatory Reference Data": <BeenhereIcon />,
  };

  const handleReferenceData = () => {
    navigate("/reference-data");
    localStorage.setItem("productCode", "");
    localStorage.setItem("regulationName", "");
  };

  const handleFileStorage = () => {
    navigate("/file-storage");
    localStorage.setItem("productCode", "");
    localStorage.setItem("regulationName", "");
  };

  const handleSettings = () => {
    navigate("/settings");
    localStorage.setItem("productCode", "");
    localStorage.setItem("regulationName", "");
  };
  const handleUKRecordKeeping = () => {
    navigate("/uk-recordkeeping-dashboard");
    handleDataEncryption("RegDataVal5", "P001", secretKey);
    handleGetDecryptedRegulationCode();
    localStorage.setItem("regulationName", "UK MIFID II Record Keeping");

    toggleDrawer("left", false);
  };
  const handleEURecordKeeping = () => {
    navigate("/eu-recordkeeping-dashboard");
    handleDataEncryption("RegDataVal5", "P004", secretKey);
    handleGetDecryptedRegulationCode();
    localStorage.setItem("regulationName", "EU MIFID II Record Keeping");
    toggleDrawer("left", false);
  };
  const handleUKCommunicationRecords = () => {
    navigate("/uk-communication-records");
    handleDataEncryption("RegDataVal5", "P002", secretKey);
    handleGetDecryptedRegulationCode();
    localStorage.setItem("regulationName", "UK Communication Records");
    toggleDrawer("left", false);
  };
  const handleEUCommunicationRecords = () => {
    navigate("/eu-communication-records");
    handleDataEncryption("RegDataVal5", "P005", secretKey);
    handleGetDecryptedRegulationCode();
    localStorage.setItem("regulationName", "EU Communication Records");
    toggleDrawer("left", false);
  };
  const handleLogout = () => {
    // logout();
    // setShowConfirmationModal(true);
    localStorage.clear();
    navigate("/login");
  };

  const defaultSideBarMenuList = {
    P004: {
      name: "EU Record Keeping",
      icon: <DvrIcon sx={{ color: "#0000008a" }} />,
      isSubscribed: false,
      handler: handleEURecordKeeping,
    },
    P001: {
      name: "UK Record Keeping",
      icon: <DvrIcon sx={{ color: "#0000008a" }} />,
      isSubscribed: false,
      handler: handleUKRecordKeeping,
    },
    P005: {
      name: "EU Communications Record",
      icon: <NfcIcon sx={{ color: "#0000008a" }} />,
      isSubscribed: false,
      handler: handleEUCommunicationRecords,
    },
    P002: {
      name: "UK Communications Record",
      icon: <NfcIcon sx={{ color: "#0000008a" }} />,
      isSubscribed: false,
      handler: handleUKCommunicationRecords,
    },
  };

  // Update subscription status based on clientDetails
  const sideBarMenuList = useMemo(() => {
    const updatedMenuList = { ...defaultSideBarMenuList };
    // console.log("clientDetails?.dataAccess  :", clientDetails?.dataAccess);
    if (clientDetails?.dataAccess) {
      Object.keys(clientDetails?.dataAccess).forEach((productCode) => {
        if (updatedMenuList[productCode]) {
          updatedMenuList[productCode].isSubscribed = true;
        }
      });
    }

    return Object.values(updatedMenuList); // easier for mapping
  }, [clientDetails]);
  const list1 = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 375 }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <div className="logo">
          <img
            src={images.Logo}
            alt="logo"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <Divider />
        <List>
          {sideBarMenuList.map((product) => (
            <ListItemButton
              key={product.name}
              onClick={(e) => {
                product.handler();
                toggleDrawer(anchor, false)(e);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              <div style={{ gap: 1, display: "flex", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
                  {product.icon}
                  <ListItemText primary={product.name} />
                </div>
              </div>

              {/* Subscription Status */}
              {product.isSubscribed ? (
                <CheckCircleIcon sx={{ color: "#28679e", fontSize: 20 }} />
              ) : (
                <LockIcon sx={{ color: "gray", fontSize: 20 }} />
              )}
            </ListItemButton>
          ))}
        </List>
        {lists.map((list) => (
          <div key={list.name}>
            <ListItem button onClick={() => handleListClick(list.name)}>
              <ListItemIcon>{listIcons[list.name]}</ListItemIcon>
              <ListItemText primary={list.name} />
              {openList === list.name ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={openList === list.name} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {list.items.map((item) => (
                  <ListItem
                    button
                    key={item}
                    sx={{ pl: 4, height: "50px" }}
                    onClick={() => handleItemClick(item)}
                  >
                    {/* <ListItemIcon> */}
                    {/* <CircleSharpIcon fontSize="very small" /> */}
                    <LockIcon
                      sx={{ color: "gray", fontSize: 18, marginRight: 2 }}
                    />
                    {/* </ListItemIcon> */}
                    <ListItemText primary={item} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </div>
        ))}
      </List>
      <Divider />
      {/* ==================================================== */}

      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={handleReferenceData}>
            <ListItemIcon>
              <DatasetIcon />
            </ListItemIcon>
            <ListItemText primary="Reference Data" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={handleFileStorage}>
            <ListItemIcon>
              <SourceIcon />
            </ListItemIcon>
            <ListItemText primary="File Storage" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={handleSettings}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </ListItemButton>
        </ListItem>
      </List>
      <List>
        <Divider />
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <PowerSettingsNewIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
  return (
    <div className="list">
      <div className="item">
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            <MenuIcon
              onClick={toggleDrawer("left", true)}
              style={{ color: "white", fontSize: 26 }}
            />
            {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              sx={{
                "& .MuiDrawer-paper": {
                  backgroundColor: "white",
                  color: "#28679e",
                  fontWeight: "bold",
                },
              }}
              disableScrollLock={true}
            >
              {list1(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>
      {/* {showConfirmationModal && (
        <FileDownloadModal
          show={showConfirmationModal}
          onHide={() => setShowConfirmationModal(false)}
          logoutText="Are you sure you want to logout?"
          logout
        />
      )} */}
    </div>
  );
}
